import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Configure, connectSearchBox, InstantSearch, Stats,} from 'react-instantsearch-dom';
import qs from 'qs'
import {withRouter} from 'react-router'
import {Link as RouterLink} from "react-router-dom";
import _map from 'lodash/map'
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import clsx from "clsx";
/*constants*/
import {autocompleteHits, ProductListHitsPerPageBlueWeeks} from "../CarsListPage/constants";
import {PAGES_SLUGS} from "../../constants";
import {
    nonEmptySearchClient,
    indexName,
    searchClient,
    sortItems
} from "../../constants/algolia";
/*actions*/
import * as actions from "../CarsListPage/actions";
/*ui*/
import {withStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Icon from "@material-ui/core/Icon";
/*components*/
import AlgoliaSortByMobile from "../../components/ContentBlocks/Cars/AlgoliaSortByMobile";
import AlgoliaSortByDesktop from "../../components/ContentBlocks/Cars/AlgoliaSortByDesktop";
import AlgoliaHitsBlue from "../../components/ContentBlocks/Cars/AlgoliaHitsBlue";
import AlgoliaPagination from "../../components/ContentBlocks/Cars/AlgoliaPagination";
import AlgoliaAutoComplete from "../../components/ContentBlocks/Cars/AlgoliaAutoComplete";
import AlgoliaFiltersMobile from "../../components/ContentBlocks/Cars/AlgoliaFiltersMobile";
import filterStyles from "../../theme/filterStyles";
import listingStyles from "../../theme/listingGeneralStyles";
import CountdownBlueWeeks from "../../components/BlueWeeks/Countdown";
/*helpers*/
import extractFilterName from "../../helpers/extractFilterName";
import {availabilityOffset, getYearAndWeek} from "../../helpers/inStock";
import RenderCarFilters from "../../components/Algolia/RenderCarFilters";
import {appStyle} from "../../theme/appStyle";

const VirtualSearchBox = connectSearchBox(() => null);

/**
 * ms until the URL updates. This is required for performance so there won't be too many pushes on filtering
 * @type {number}
 */
const ulrDebounceTimer = 200;

const customStyles = theme => ({
    ...appStyle(theme),
    ...filterStyles(theme),
    ...listingStyles(theme),
    dealerHeaderAlign: {
        [theme.breakpoints.between('md', 'lg')]: {
            flexWrap: 'nowrap',
            justifyContent: 'space-between'
        },
    },
    blueBackToListing: {
        [theme.breakpoints.down('md')]: {
            marginBottom: theme.spacing(2),
        },
        [theme.breakpoints.up('md')]: {
            position: `absolute`,
            left: theme.spacing(2),
            top: theme.spacing(2),
        },

        '& .brand-icon-back': {
            fontSize: `14px !important`
        }
    }
});

class CarListingBlueWeeks extends Component {
    state = {
        openFilterDialog: false,
        openFilterSideMenu: false,
        searchState: {
            query: this.props.defaultQuery
        },
        facets: {},
        openSearchDialog: false
    };

    componentDidMount() {
        this.fetchDynamicFacets();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /**
         * Update the state when clicking the bottom navigation button
         * Or when using See all in autocomplete
         */
        if (this.props.location.search !== prevProps.location.search) {
            this.setState({searchState: this.urlToSearchState(this.props.location)})
        }

        /**
         * Save the facets we get from Algolia in this.state with key: value
         * extractFilterName: Algolia-facet-name; ex.: category: category.name
         * This is required when encoding and decoding the URLs
         */
        // console.log('this.props.facets', this.props.facets);
        if (_isEmpty(this.state.facets) && this.props.facets.length !== 0) {
            const facetNameSync = {};
            this.props.facets.map((facet) => {
                facetNameSync[extractFilterName(facet)] = facet
            })
            // console.log('facetNameSync', facetNameSync);
            this.setState({
                facets: {
                    ...facetNameSync
                },
            }, () => {
                /**
                 * Because we have dynamic facets, we need those to convert the URL to search state
                 * This is why the searchState is empty and not initialized on mount
                 */
                this.setState({searchState: this.urlToSearchState(this.props.history.location)})
            })
        }
    }

    fetchDynamicFacets = () => {
        this.props.fetchFacets();
    };

    handleFiltersDialog = () => {
        this.setState({openFilterDialog: !this.state.openFilterDialog});
    };

    onSearchStateChange = searchState => {
        // console.log(this.searchStateToUrl(this.props.location.pathname, searchState));
        // console.log('searchState',searchState);

        clearTimeout(this.debouncedSetState);

        this.debouncedSetState = setTimeout(() => {
            this.props.history.push(this.searchStateToUrl(this.props.history.location.pathname, searchState),
                searchState)
        }, ulrDebounceTimer);

        this.setState({searchState});
    };

    /* SNOWPLOW - track searchbar input*/
    handleSearchStateChange = ({ query }) => {
        if (query && query !== "") {
            // If there's a query and it's not an empty string, track it with Snowplow
            if (window.snowplow) {
                window.snowplow('trackSiteSearch', {
                    terms: [query],
                });
            }
        }
    };

    createURL = state => {
        const noFacetsSelected = () => {
            if (_isEmpty(state.refinementList)) return true
            return Object.values(state.refinementList).every(item => item === '');
        }

        const noPriceRangeSelected = () => {
            if (!state.range) return true
            return _get(
                state.range, 'client_invoice_price.min', '') === ''
                && _get(state.range, 'client_invoice_price.max', '') === '';
        }

        /**
         * Changed to arrival_date_segment
         * Blue weeks has by default this set
         */
        // const noStockRangeSelected = () => {
        //     if (!state.range) return true
        //     return (_get(state.range, 'arrival_date.min', '') === ''
        //         && _get(state.range, 'arrival_date.max', '') === ''
        //     );
        // }

        const isDefaultRoute =
            // No query string
            !state.query
            // First page
            && state.page === 1
            // All facets are empty arrays or none exists
            && noFacetsSelected()
            // No sorting
            && (!state.sortBy || state.sortBy === indexName)
            // Price input values
            && noPriceRangeSelected()
            // && noStockRangeSelected()

        // Not used; fully replaced this mechanics with custom input values
        // No numeric filtering
        // && !state.multiRange

        if (isDefaultRoute) {
            return '';
        }

        const queryParameters = {};

        if (state.query) {
            queryParameters.query = state.query;
        }
        if (state.page !== 1) {
            queryParameters.page = state.page;
        }
        if (state.sortBy) {
            const sorting = state.sortBy.replace(`${indexName}_`, "");
            /**
             * indexName is the unsorted index
             * indexName + '_sort_type'
             * Equal if there is no sort
             */
            if (sorting !== indexName) {
                queryParameters.sortBy = sorting;
            }
        }

        /**
         * Process the refinements if any
         */
        if (state.refinementList) {
            // console.log('state.refinementList', state.refinementList);
            for (let [key, value] of Object.entries(state.refinementList)) {
                // console.log(`${key}: ${value}`);
                if (value) {
                    queryParameters[extractFilterName(key)] = value;
                }
            }
        }

        /**
         * Process the price inputs
         */
        if (!noPriceRangeSelected()) {
            const priceRange = state.range.client_invoice_price;
            // console.log(priceRange);
            if (!priceRange.min && priceRange.max) {
                /// If there's only a max value
                queryParameters.price = `0:${priceRange.max}`
            } else if (priceRange.min && !priceRange.max) {
                /// If there's only a min value
                queryParameters.price = `${priceRange.min}`
            } else {
                /// If both values are present
                queryParameters.price = `${priceRange.min}:${priceRange.max}`
            }
        }

        /**
         * For blue weeks, stock filter must be true, but without displaying it in the URL
         */
        /*if (!noStockRangeSelected()) {
            queryParameters.inStock = `true`
        }*/

        // qs.stringify encodes the URL
        // No need to use encodeURIComponent on any value
        const queryString = qs.stringify(queryParameters, {
            addQueryPrefix: true,
            arrayFormat: 'repeat',
        });
        // console.log('queryString', queryString);

        return `${queryString}`;
    };

    searchStateToUrl = (pathname, searchState) => {
        console.log('searchStateToUrl', searchState);
        return searchState ? `${pathname}${this.createURL(searchState)}` : '';
    }

    urlToSearchState = location => {
        const queryParameters = qs.parse(location.search.slice(1));
        const {query = '', page = 1, price = ''} = queryParameters;
        const sortBy = queryParameters.sortBy ? `${indexName}_${queryParameters.sortBy}` : indexName
        const refinementList = {};
        const range = {};

        /**
         * Parse the facets and see if there are any in refinementList
         */
        // console.log('refinementList', refinementList);
        _map(Object.keys(queryParameters), (parameter) => {
            if (this.state.facets[parameter]) {
                // console.log(parameter, 'in Alogilia is', this.state.facets[parameter]);
                /**
                 * All values in refinementList must be arrays even if it contains a single element
                 */
                refinementList[this.state.facets[parameter]] = Array.isArray(queryParameters[parameter]) ? queryParameters[parameter] : [queryParameters[parameter]].filter(Boolean)
            }
        })

        /**
         * Change this if price URL notation changes
         * Current:
         * valMin:valMax
         * valMin:
         * Need to check if the priceRange from the url contains one element
         */
        if (price !== '') {
            const priceRange = price.split(':');
            console.log('priceRange urlToSearchState', priceRange);
            /**
             * Mechanics is similar to multiRange
             * Moved the refining logic to InputMenu
             */

            if (priceRange.length === 1) {
                // console.log(`priceRange.length ${priceRange.length}`);
                /**
                 * If the greaterThan numericMenu was selected
                 * of if the InputMenu has only min value
                 * ["75000"]
                 */
                range.client_invoice_price = {min: priceRange[0]}
            } else if (priceRange[0] === '0') {
                // console.log(`priceRange[0] ${priceRange[0]}`);
                /**
                 * If the lowerThan numericMenu was selected
                 * of if the InputMenu has only max value
                 * ["0", "40000"]
                 */
                range.client_invoice_price = {max: priceRange[1]}
            } else {
                // console.log(`${priceRange[0]}-${priceRange[1]}`);
                /**
                 * If interval was selected in the numericMenu
                 * of if the InputMenu has both min and max values
                 * ["28000", "42000"]
                 */
                range.client_invoice_price = {min: priceRange[0], max: priceRange[1]}
            }
        }

        range.arrival_date_segment = {max: getYearAndWeek(availabilityOffset.now.end)}

        return {
            query: query,
            page,
            sortBy: sortBy,
            refinementList: {
                ...refinementList
            },
            range: {
                ...range
            }
        };
    };

    render() {
        const {classes} = this.props
        return (
                (_isEmpty(this.state.facets)) ? (
                    <Box
                        width={"100%"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}>
                        <CircularProgress size={24}/>
                    </Box>
                ) : (
                    <InstantSearch indexName={indexName}
                                   searchClient={searchClient}
                                   onSearchStateChange={this.onSearchStateChange}
                                   searchState={this.state.searchState}
                                   createURL={this.createURL}
                    >

                        <Box bgcolor="primary.dark" pt={5}>
                            <Grid container alignContent={"stretch"} className={classes.listingContainer}>
                                <Grid item xs={12}>
                                    <Grid container direction="column" alignItems="center">
                                        <Button
                                            className={`${classes.whiteText} ${classes.weight300} ${classes.blueBackToListing}`}
                                            variant="outlined"
                                            color="inherit"
                                            startIcon={<Icon className={clsx("brand-icon-back", classes.icon)}/>}
                                            component={RouterLink} to={`/${PAGES_SLUGS.PRODUCTS}`}
                                        >
                                            Înapoi la site-ul principal
                                        </Button>
                                        <Typography variant={"h1"} align={"center"}
                                                    className={`${classes.weight500} ${classes.pageTitle} ${classes.whiteText}`}>
                                            Oferte Volvo Blue Weeks
                                        </Typography>

                                        <Grid container justify={"center"}>
                                            <CountdownBlueWeeks/>
                                        </Grid>
                                        <Box width={"100%"} pt={3}></Box>

                                        <Typography variant={"subtitle2"} align={"center"}
                                                    className={`${classes.weight300} ${classes.pageSubtitle} ${classes.whiteText}`}>
                                            Livrare imediată <span className={classes.sidePadding}>/</span> 4 ani garanție
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>

                        <Grid container alignContent={"stretch"} className={classes.listingContainer}>
                            <Box width={"100%"} pt={5}></Box>
                            <Grid item xs={12} className={classes.searchBarContainer}>
                                <Grid container>
                                    <Grid item xl={2} lg={2} md={3} xs={false}>
                                    </Grid>
                                    <Grid item xl={8} lg={10} md={9} xs={12}>
                                        {/*Use different alignment on dealership page because of the missing search input*/}
                                        <Grid container spacing={3} className={this.props.isDealerPage ? classes.dealerHeaderAlign : ''}>
                                            <Grid container item xs={12} lg={3} alignItems="center"
                                                  className={classes.searchSubtitle}>
                                                <Typography variant={"subtitle2"}
                                                            className={`${classes.weight300}`}>
                                                    <Stats
                                                        translations={{
                                                            stats(nbHits) {
                                                                return nbHits === 1
                                                                    ? `Lista cuprinde ${nbHits} mașină.`
                                                                    : `Lista cuprinde ${nbHits} mașini.`;
                                                            },
                                                        }}
                                                    />
                                                </Typography>
                                            </Grid>
                                            { !this.props.isDealerPage && <Grid item md={6} xs={12} className={classes.searchInputParent}>
                                                <div className={`${classes.relative}`}>
                                                    {/*Contains both desktop and mobile version*/}
                                                    {/*Separate instance so each has it's own refinement*/}
                                                    <InstantSearch indexName={indexName} searchClient={nonEmptySearchClient}   onSearchStateChange={this.handleSearchStateChange}>
                                                        <AlgoliaAutoComplete indexName={indexName}/>
                                                        <Configure hitsPerPage={autocompleteHits}/>
                                                    </InstantSearch>
                                                </div>
                                            </Grid>}
                                            <Grid item xs={6}
                                                  className={`${classes.mobileFilterParent} ${classes.hiddenMdUp}`}>
                                                <Button
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    aria-describedby="sortToggle"
                                                    onClick={this.handleFiltersDialog}
                                                    className={`${classes.sortButton}`}
                                                >

                                                    <Typography variant={"body1"}
                                                                className={`${classes.weight300} ${classes.sortButtonText}`}><Icon
                                                        className={`${classes.iconRightMargin} brand-icon-filter`}/>Filtrează</Typography>
                                                    <Icon className={`${classes.sortIcon} brand-icon-down-arrow`}
                                                          color={"primary"}/>
                                                </Button>
                                            </Grid>
                                            <AlgoliaFiltersMobile
                                                facets={this.props.facets}
                                                open={this.state.openFilterDialog}
                                                onClose={this.handleFiltersDialog}
                                                onSearchStateChange={this.onSearchStateChange}
                                                searchState={this.state.searchState}
                                                isDealerPage={this.props.isDealerPage}
                                            />
                                            <Grid container item xs={6} lg={3} alignItems="center" justify="flex-end"
                                                  className={`${classes.sortParent} ${classes.hiddenXlUp}`}>

                                                <AlgoliaSortByMobile
                                                    defaultRefinement={indexName}
                                                    items={sortItems}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>


                            <Grid item xl={2} lg={2} md={3}
                                  className={`${classes.filterContainer} ${classes.hiddenSmDown}`}
                            >
                                <VirtualSearchBox defaultRefinement={this.state.searchState.query}/>
                                {/*This creates a clickable link which adds the `menu` object to the search state*/}
                                {/*<Menu attribute="categories.name" />*/}

                                <Typography variant={"body1"}
                                            className={`${classes.weight300} ${classes.mechanicsTitle}`}>
                                    Filtrează după specificații:
                                </Typography>
                                {/*{this.renderDesktopFilters()}*/}
                                <RenderCarFilters
                                    facets={this.props.facets}
                                    isDealerPage={this.props.isDealerPage}
                                />
                                <Configure hitsPerPage={ProductListHitsPerPageBlueWeeks}/>
                            </Grid>

                            <Grid item xl={8} lg={10} md={9} sm={12} xs={12}>
                                <Grid container spacing={3}>
                                    <AlgoliaHitsBlue />
                                </Grid>

                                <Grid container justify={"center"}
                                      className={`${classes.paginationGrid} ${classes.relative}`}>
                                    <AlgoliaPagination
                                        showPrevious={true}
                                        showNext={true}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xl={2} className={`${classes.hiddenLgDown} ${classes.stickySort}`}>
                                <AlgoliaSortByDesktop
                                    defaultRefinement={indexName}
                                    items={sortItems}
                                />
                            </Grid>
                        </Grid>
                    </InstantSearch>
                )
        )
    };
}

function mapStateToProps(state) {
    return {
        location: state.router.location,
        facets: state.cars.facets.data,
    }
}

CarListingBlueWeeks = withRouter(CarListingBlueWeeks);
CarListingBlueWeeks = withStyles(customStyles)(CarListingBlueWeeks);
CarListingBlueWeeks = connect(mapStateToProps, {...actions})(CarListingBlueWeeks);

export default CarListingBlueWeeks;
